import { createContext, useContext } from 'react';

const AblyContext = createContext(null);

// eslint-disable-next-line react/prop-types
export function AblyProvider({ client, children }) {
  return <AblyContext.Provider value={client}>{children}</AblyContext.Provider>;
}

export const useAbly = () => {
  const client = useContext(AblyContext);
  if (!client) {
    throw new Error('useAbly must be used within an AblyProvider');
  }
  return client;
};
